/**
 * Redux Slice para gerenciamento do estado do mapa
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MapState, Coordinates } from '../../types';
import { config } from '../../utils/config';

const initialState: MapState = {
  center: config.defaultCenter,
  zoom: config.defaultZoom,
  radius: config.defaultRadius,
  isSelectingLocation: false
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setCenter: (state, action: PayloadAction<Coordinates>) => {
      state.center = action.payload;
    },
    setZoom: (state, action: PayloadAction<number>) => {
      state.zoom = action.payload;
    },
    setSelectedLocation: (state, action: PayloadAction<Coordinates | undefined>) => {
      state.selectedLocation = action.payload;
    },
    setRadius: (state, action: PayloadAction<number>) => {
      state.radius = Math.max(
        config.minRadius,
        Math.min(config.maxRadius, action.payload)
      );
    },
    setIsSelectingLocation: (state, action: PayloadAction<boolean>) => {
      state.isSelectingLocation = action.payload;
    },
    resetMapState: (state) => {
      state.center = config.defaultCenter;
      state.zoom = config.defaultZoom;
      state.selectedLocation = undefined;
      state.radius = config.defaultRadius;
      state.isSelectingLocation = false;
    }
  }
});

export const {
  setCenter,
  setZoom,
  setSelectedLocation,
  setRadius,
  setIsSelectingLocation,
  resetMapState
} = mapSlice.actions;

export default mapSlice.reducer;





